import { gql } from 'apollo-angular';

export const GET_PHASESMASTERS = gql`
  query PhasesMasters {
    phasesMasters {
      id
      name
      type
    }
  }
`;
